import * as XLSX from "xlsx";

export function generateExcelFile(sheetName, fileName, sheetData) {
  let wb = XLSX.utils.book_new();
  let ws = XLSX.utils.json_to_sheet(sheetData);

  XLSX.utils.book_append_sheet(wb, ws, fileName);
  XLSX.writeFile(wb, sheetName);
}
